import React from 'react';
import { Grid, Typography,  withStyles, InputBase, TextField , Divider, Paper, CircularProgress } 
from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
    typography: {
      subtitle1: {
        fontSize: 15,
        color: "rgb(0, 0, 0, 0.5)",
      },
      body1: {
        fontSize: 15,
        fontWeight: 500,
      },
      caption: {
        fontSize: 12,
      },
      caption2: {
        fontSize: 12,
        fontWeight: 500
      },
      h5: {
        fontWeight: 500
      },
      h4: {
        fontWeight: 600,
        color: '#008675'
      },
      subtitle2: {
        fontSize: 12,
        color: "#999999",
      },
      body2: {
        fontSize: 12,
        fontWeight: 600,
        color: "#999999",
      },
    },
  });

const textLabel = (gridWidth, variant, text, style) => {
    return(
        <Grid item sm={gridWidth} md={gridWidth} lg={gridWidth} style={style} >
            <ThemeProvider theme={theme}>
                <Typography variant={variant}>{text}</Typography>
            </ThemeProvider>
        </Grid>
    );
};
const textLabelBold = (variant, text, color) => {
  return(
        <ThemeProvider theme={theme}>
            <Typography variant={variant} color={color}>{text}</Typography>
        </ThemeProvider>
  );
};
const textValPair = (gridWidth, label, v1, value, v2) => {
  return(
      <Grid item sm={gridWidth} md={gridWidth} lg={gridWidth} >
          <ThemeProvider theme={theme}>
              <Typography variant={v1}>{label} </Typography>
              <Typography variant={v2}>{value} </Typography>
          </ThemeProvider>
      </Grid>
  )
}
const labelMoneyIcon = (gridWidth, label, value) => {
  return(
      <Grid item sm={gridWidth} md={gridWidth} lg={gridWidth} >
          <ThemeProvider theme={theme}>
                  <Typography variant="subtitle2">{label}</Typography>
                  <Typography variant="body1">${value}</Typography>
          </ThemeProvider>
      </Grid>
  );
};

const getClaimId = (id) => {
    const parts = id && id.split('-');
    const claimId = parts && parts.pop();
    return claimId;
}

const getDecimalVal = (val) => {
  return Number(val).toFixed(2);
}

const DividerFullWidth = (props) => {
  return (
    <Grid item key={props.key} xs={12} md={12} lg={12}>
      <Divider variant="fullWidth" />
    </Grid>
  );
};

const TextBoxField = (pname, placeholder, changehandler, value) => {
  return (
          <TextField name={pname}
               id={pname}
               placeholder={placeholder} 
               onChange={changehandler} 
               value={value}
               variant="outlined"
               color="secondary" 
               inputProps={{
                style: {padding: '6px', minWidth: '250px'}
               }}
               />
               
    
  );
} 

const text = (variant, value, style) => {
  return (
      <Typography variant={variant} color={"textPrimary"} style={style}>{value}</Typography>
  );
}
const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid rgba(211,211,211, 0.8)',
    fontSize: 15,
    color: 'black',
    padding: '5px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 0,
      borderColor: 'rgba(245, 0, 87)'
    },
  },
}))(InputBase);



 const subHeaderLabel = (label) => {
   return (
    <Paper elevation={1} style={{ padding: "5px", backgroundColor: "#D9D9D6"}}>
      <Typography variant="subtitle1" color="primary">{label}</Typography>
    </Paper>
   )
 }
 const textField = (props) => {
  const {input, meta : {touched, warning}, label, type, error, isIcon, multiline, handleShow, ...custom} = props;
  return (
      <div>
          <Typography variant="caption">{label} </Typography>
          <TextField
          name={input.name}
          id={input.name}
          error={touched && (error==='Required')}
          helperText={touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span>{warning}</span>))}
          margin="normal"
          size="small"
          variant="outlined" 
          fullWidth={true}
          multiline={multiline}
          rows={multiline?4:1}              
          {...input}
          {...custom}
          style={{backgroundColor: 'white', marginTop: "0"}}
          
      />
      </div>  
  );
}

const isLoading = (loading) => {
  if (loading) {
      return (
          <CircularProgress
              size={70}
              color={"secondary"}
              style={{position: 'absolute', jusitfyContent: 'center', top: 0, left: 0, bottom: 0, right: 0, margin: 'auto'}}
          />
      );
  } else {
      return null;
  }
}

export { 
  textLabel, TextBoxField, getClaimId, labelMoneyIcon, textField, isLoading,
  getDecimalVal, textValPair, DividerFullWidth, text, BootstrapInput, subHeaderLabel, textLabelBold
};